import { render, staticRenderFns } from "./Unavailable.vue?vue&type=template&id=61eb85ca&scoped=true"
import script from "./Unavailable.vue?vue&type=script&lang=js"
export * from "./Unavailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61eb85ca",
  null
  
)

export default component.exports